import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=bf0cc728&scoped=true"
var script = {}
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=bf0cc728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0cc728",
  null
  
)

export default component.exports